import { CurrencyRateAPI } from "../api"
import Helper from "../plugins/Helper/Helper"

export class CurrencyRate {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }

    if (props.data) {
      let data = props.data
      for (let key in data) {
        for (let key2 in data[key]) {
          data[key][key2].value = Helper.roundCurrency(data[key][key2].value)
        }
      }
      this.data = data
    }
    this.lastUpdate = props.lastUpdate.iso
  }

  static async getCurrencyRateByDate(payload) {
    const { data } = await CurrencyRateAPI.getCurrencyRateByDate(payload);
    return data.result ? new CurrencyRate(data.result) : null
  }
  static async getLastCurrencyRate() {
    const { data } = await CurrencyRateAPI.getLastCurrencyRate();
    return data.result ? new CurrencyRate(data.result) : null
  }
}